<div class="container-fluid" *ngIf="availableNotificationTypes">
  <form [formGroup]="createNotificationForm">
    <div style="margin-bottom: 40px;">
    <div class="row" [padding-top]="15">
      <div class="col-sm-12 field">
        <label [for]="'notificationType'" class="block">
          Select notification type
        </label>
        <p-dropdown
          (onChange)="onSelectedNotificationTypeChanged()"
          [options]="availableNotificationTypes"
          class="width-100"
          id="notificationType"
          formControlName="notificationType"
        ></p-dropdown>
        <small *ngIf="selectedNotificationInstance" class="block mt-1">
          <i class="pi pi-info-circle" [padding-right]="2" style="color:chocolate;"></i>{{ selectedNotificationInstance.Description }}
        </small>
      </div>
    </div>
    <div class="row" [padding-top]="15">
      <div class="col-sm-12 field">
        <label [for]="'targetType'" class="block"> Select target type </label>
        <p-dropdown
          (onChange)="onSelectedTargetTypeChanged($event)"
          [options]="availableTargetOptions"
          class="width-100"
          id="targetType"
          formControlName="targetType"
        ></p-dropdown>
      </div>
    </div>
    <div class="row" [padding-top]="15">
      <div class="col-sm-12 field">
        <div [ngSwitch]="selectedTargetType">
          <span class="p-float-label"></span>
          <div *ngSwitchCase="'company_group'" class="field">
            <label [for]="'selectedCompanyGroup'" class="block">
              Select organization
            </label>
            <span class="p-fluid">
              <p-autoComplete
                [suggestions]="companyGroupCollection"
                (completeMethod)="searchCompanyGroup($event)"
                [showEmptyMessage]="true"
                [multiple]="true"
                class="width-100"
                inputStyleClass="width-100"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                field="label"
                appendTo="body"
                formControlName="selectedCompanyGroup"
              ></p-autoComplete>
            </span>
          </div>
          <div *ngSwitchCase="'location'" class="field">
            <label [for]="'selectedLocation'" class="block">
              Select location
            </label>
            <span class="p-fluid">
              <p-autoComplete
                [suggestions]="locationCollection"
                (completeMethod)="searchLocation($event)"
                [forceSelection]="true"
                [showEmptyMessage]="true"
                [multiple]="true"
                class="width-100"
                inputStyleClass="width-100"
                [style]="{ width: '100%' }"
                [inputStyle]="{ width: '100%' }"
                field="label"
                formControlName="selectedLocation"
              ></p-autoComplete>
            </span>
          </div>
          <div *ngSwitchCase="'user'">
            <div class="field">
              <label [for]="'selectedLocation'" class="block">
                Select location
              </label>
              <span class="p-fluid">
                <p-autoComplete
                  [suggestions]="locationCollection"
                  (completeMethod)="searchLocation($event, true)"
                  [forceSelection]="true"
                  [showEmptyMessage]="true"
                  [multiple]="true"
                  class="width-100"
                  inputStyleClass="width-100"
                  [style]="{ width: '100%' }"
                  [inputStyle]="{ width: '100%' }"
                  field="label"
                  formControlName="selectedLocation"
                ></p-autoComplete>
              </span>
            </div>
            <div  class="field">
              <label [for]="'selectedUser'" class="block" style="padding-top:10px"> Select user </label>
              <span class="p-fluid">
                <p-autoComplete
                  [suggestions]="userCollection"
                  (completeMethod)="searchUser($event)"
                  [forceSelection]="true"
                  [showEmptyMessage]="true"
                  [multiple]="true"
                  class="width-100"
                  inputStyleClass="width-100"
                  [style]="{ width: '100%' }"
                  [inputStyle]="{ width: '100%' }"
                  field="label"
                  formControlName="selectedUser"
                ></p-autoComplete>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container>
      <div
        class="row"
        style="gap: 1rem"
        [padding-top]="15"
        formArrayName="dynamicFields"
      >
        <ng-container
          *ngFor="let field of dynamicFieldsMetadata; let i = index"
        >
          <div
            class="field"
            [ngClass]="'col-' + (field.ColSpan ? field.ColSpan : 6)"
            [style.gridRow]="field.Row"
          >
            <span class="field">
              <label [for]="field.Code" class="block">
                {{ field.Label }}
              </label>

              <!-- Text -->
              <input
                *ngIf=" !field.RowSpan && (
                  field.DataType.trim() == 'text' ||
                  field.DataType.trim() == 'url'
                )
                "
                pInputText
                [id]="field.Code"
                [type]="field.DataType.trim() == 'url' ? 'url' : 'text'"
                [formControlName]="field.Code"
                [readonly]="field.Editable === true"
                [attr.maxLength]="field.MaxLength"
                class="width-100"
              />

              <textarea
                *ngIf="field.RowSpan && (
                  field.DataType.trim() == 'text' ||
                  field.DataType.trim() == 'url'
                )
                "
                pInputTextarea
                [id]="field.Code"
                [rows]="field.RowSpan"
                [formControlName]="field.Code"
                [readonly]="field.Editable === true"
                [attr.maxLength]="field.MaxLength"
                class="width-100 p-textarea"
              >

              </textarea>

              <!-- Date -->
              <p-calendar
                *ngIf="field.DataType.trim() == 'date'"
                [id]="field.Code"
                formControlName="{{ field.Code }}"
                [readonlyInput]="field.Editable === true"
                dateFormat="yy-mm-dd"
                [showIcon]="true"
                class="width-100"
                [style]="{ width: '100%' }"
                [appendTo]="'body'"
              >
              </p-calendar>
            </span>
            <small
              class="p-error block mt-1"
              *ngIf="
                createNotificationForm.controls.dynamicFields?.controls[field.Code]?.invalid &&
                createNotificationForm.controls.dynamicFields?.controls[field.Code]?.touched
              "
            >
              {{ field.Label }} field is mandatory!
            </small>
          </div>
        </ng-container>
      </div>
    </ng-container>

    </div>
    <footer class="mt-auto">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-5 text-m">
          <button
            pButton
            type="button"
            class="p-button-raised p-button-rounded p-button p-button-sm edit"
            label="Save as draft"
            [disabled]="!createNotificationForm.valid"
            (click)="saveNotification(false)"
          ></button>
        </div>
        <div class="col-md-3 text-m">
          <button
            pButton
            type="button"
            class="p-button-raised p-button-rounded p-button p-button-sm"
            [disabled]="!createNotificationForm.valid"
            label="Publish"
            (click)="saveNotification(true)"
          ></button>
        </div>
      </div>
    </footer>
  </form>
</div>
